export const ErrorCode = {
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL: 'INTERNAL',
    /**
     * Rasm muddati tugagan — kod NOTO'G'RI TERILGANI EMAS.
     *
     * Ikkalasi ham 400 qaytaradi, lekin mijoz uchun bular butunlay boshqa
     * hodisa: birinchisida odam hech qanday xato qilmagan va unga "kod
     * noto'g'ri" deyish yolg'on bo'lardi.
     */
    CAPTCHA_EXPIRED: 'CAPTCHA_EXPIRED',
    /**
     * Qoldiq yetmadi — so'rov XATO TERILGANI EMAS.
     *
     * Oddiy `VALIDATION_FAILED` dan ajratilgan sababi: bu yerda odam hech
     * qanday xato qilmagan. U yozgan payt mahsulot bor edi, boshqa korxona
     * uni oldinroq so'rab ulgurdi. Mijoz bu javobga matn ko'rsatib emas,
     * TANLOV taklif qilib javob beradi ("bor qismini yuborish" yoki
     * "qolganiga bildirgi") va buning uchun kodni ajrata olishi shart.
     *
     * `details` — `insufficientStockDetailsSchema`.
     */
    INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
};
//# sourceMappingURL=errors.js.map